export const NOT_SET = 'NOT_SET';

export const CADRE_ETUDE = 'CadreEtude';
export const CADRE_ETUDE_AFFIXE = 'CadreEtudeAffixe';

export const TYPE_DOSSIER = 'TypeDossier';

export const PHASE_DOSSIER = 'PhaseDossier';

export const NATURE = 'Nature';

export const SECRET_DOSSIER = 'SecretDossier';

export const DOSSIER_COPYRIGHT = 'DossierCopyright';

/*
 * Intérêt et protection
 */
export const PROTECTION_OEUVRE_ARCHI = 'ProtectionOeuvreArchi';
export const PROTECTION_OEUVRE_OBJET = 'ProtectionOeuvreObjet';

export const STATUT = 'Statut';

export const SITE_PROTECTION = 'SiteProtection';
export const INTERET_OEUVRE = 'InteretOeuvre';

/*
 * Localisation
 */
export const AIRE_ETUDE = 'AireEtude';
export const CANTON = 'Canton';
export const COMMUNE = 'Commune';
export const MILIEU_IMPLANTATION = 'MilieuImplantation';
export const ADRESSE_NOM_RUE = 'AdresseNomRue';
export const ADRESSE_TYPE_VOIE = 'AdresseTypeVoie';
export const LIEU_DIT_NOM = 'LieuDitNom';
export const LIEU_DIT_PRECISION = 'LieuDitPrecision';
export const PRECISION_LOCALISATION = 'PrecisionLocalisation';

export const HYDROGRAPHIE_NOM = 'HydrographieNom';
export const HYDROGRAPHIE_PRECISION = 'HydrographiePrecision';

export const DEPLACEMENT_OEUVRE_OBJET = 'DeplacementOeuvreObjet';

/*
 * Historique
 */
export const ORIGINE = 'Origine';
export const LIEU_EXECUTION = 'LieuExecution';

export const DATATION_JUSTIFICATION = 'DatationJustification';
export const DATATION_PERIODE = 'DatationPeriode';
export const REMPLOI_INTRO = 'RemploiIntro';
export const DEPLACEMENT_INTRO = 'DeplacementIntro';

export const PROFESSION_AUTEUR_OEUVRE_ARCHITECTURE =
  'ProfessionAuteurOeuvreArchitecture';
export const PROFESSION_AUTEUR_OEUVRE_OBJET = 'ProfessionAuteurOeuvreObjet';
export const PROFESSION_PERSONNALITE = 'ProfessionPersonnalite';
export const PROFESSION_AFIG = 'ProfessionAfig';
export const PROFESSION_ATELIER_ECOLE = 'ProfessionAtelierEcole';

export const JUSTIFICATION_PROFESSION = 'JustificationProfession';

export const STADE_CREATION = 'StadeCreation';

export const STADE_CREATION_AFFIXE = 'StadeCreationAffixe';

/*
 * Désignation
 */
export const APPELLATION_ARCHI = 'AppellationArchi';
export const APPELLATION_OBJET = 'AppellationObjet';

export const DENOMINATION_ARCHI = 'DenominationArchi';
export const DENOMINATION_OBJET = 'DenominationObjet';

export const TITRE = 'Titre';

export const GENRE = 'Genre';
export const VOCABLE = 'Vocable';

/*
 * Description
 */

export const INSCRIPTION_VALEUR = 'InscriptionValeur';
export const INSCRIPTION_AFFIXE = 'InscriptionAffixe';

export const MUR_MATERIAU_GROS_OEUVRE = 'MurMateriauGrosOeuvre';
export const MUR_MISE_EN_OEUVRE = 'MurMiseEnOeuvre';
export const MUR_REVETEMENT = 'MurRevetement';

export const DIMENSION_UNITE = 'DimensionUnite';

export const TYPE_MESURE = 'TypeMesure';

export const PLAN = 'Plan';

export const ETAGE = 'Etage';

export const ELEVATION = 'Elevation';

export const JARDIN = 'Jardin';

export const ETAT_CONSERVATION_ARCHI = 'EtatConservationArchi';
export const ETAT_CONSERVATION_OBJET = 'EtatConservationObjet';

export const TYPOLOGIE = 'Typologie';

export const AUTRE_ORGANE_CIRCULATION = 'AutreOrganeCirculation';

export const COUVERTURE_TYPE = 'CouvertureType';
export const COUVERTURE_FORME = 'CouvertureForme';
export const COUVERTURE_PARTIE_TOIT = 'CouverturePartieToit';

export const TOIT = 'Toit';

export const COUVREMENT_VALEUR = 'CouvrementValeur';
export const COUVREMENT_AFFIXE = 'CouvrementAffixe';

export const REPRESENTATION_VALEUR = 'RepresentationValeur';
export const REPRESENTATION_SYMBOLE = 'RepresentationSymbole';

export const ESCALIER_EMPLACEMENT = 'EscalierEmplacement';
export const ESCALIER_FORME = 'EscalierForme';
export const ESCALIER_STRUCTURE = 'EscalierStructure';

export const ENERGIE_NATURE = 'EnergieNature';
export const ENERGIE_ORIGINE = 'EnergieOrigine';
export const ENERGIE_MACHINE = 'EnergieMachine';

export const TECHNIQUE = 'Technique';

export const CATEGORIE = 'Categorie';

export const STRUCTURE_LIBELLE = 'StructureLibelle';
export const STRUCTURE_AFFIXE = 'StructureAffixe';

export const MATERIAU_PRINCIPAL = 'MateriauPrincipal';
export const MATERIAU_TECHNIQUE = 'MateriauTechnique';
export const MATERIAU_AFFIXE = 'MateriauAffixe';

export const REPRESENTATION_CARACTERE_GENERAL =
  'RepresentationCaractereGeneral';
export const REPRESENTATION_THEME = 'RepresentationTheme';
export const REPRESENTATION_SUJET = 'RepresentationSujet';

export const COLLECTION = 'Collection';

/*
 * Illustrations
 */
export const ILLUSTRATION_CODE_REGIONAL = 'IllustrationCodeRegional';
export const ILLUSTRATION_TYPE_SUPPORT = 'IllustrationTypeSupport';
export const ILLUSTRATION_DIFFUSION = 'IllustrationDiffusion';
export const ILLUSTRATION_TECHNIQUE_RELEVE = 'IllustrationTechniqueReleve';
export const ILLUSTRATION_SENS = 'IllustrationSens';
export const ILLUSTRATION_SUJET = 'IllustrationSujet';
export const ILLUSTRATION_FORMAT = 'IllustrationFormat';
export const ILLUSTRATION_TYPOLOGIE_SUPPORT = 'IllustrationTypologieSupport';
export const ILLUSTRATION_COPYRIGHT = 'IllustrationCopyright';
export const NUMERISATION = 'Numerisation';
export const ETAT_SUPPORT = 'EtatSupport';

/*
 * Références documentaires
 */
export const LIEU_CONSERVATION = 'LieuConservation';

/*
 * Liens web
 */
export const ROLE_LIEN_WEB = 'RoleLienWeb';

/*
 * Biblio
 */
export const BIBLIO_TYPE = 'BiblioType';

export const BIBLIO_ROLE_AUTEUR = 'BiblioRoleAuteur';

export const BIBLIO_MODE_ACQUISITION = 'BiblioModeAcquisition';

export const BIBLIO_LANGUE = 'BiblioLangue';
